// eslint-disable-next-line vue/attribute-hyphenation
<template>
  <CustomerMcs :company-id="companyId" :agent-id="userId" @leave="leave" @logout="logout" />
</template>

<script>
import CustomerMcs from '@telexpress_auth/vue-mcs/dist/components/customerMcs.umd.min';
import '@telexpress_auth/vue-mcs/dist/components/customerMcs.css';
import Vue from 'vue';
import store from '@/store';

export default {
  components: {
    CustomerMcs,
  },
  data() {
    return {
      leavepopup: true,
      companyId: '',
      isAllChatClose: true,
      userId: ''
    };
  },
  created() {
    this.leavepopup = true;
    this.companyId = store.getters.company;
    this.userId = store.getters.userId;
  },
  methods: {
    leave(data) {
      if (data) { this.isAllChatClose = false; } else { this.isAllChatClose = true; }
    },
    logout() {
      this.Message = {
        userId: this.userId,
        companyId: this.companyId
      };
      Vue.prototype.$connect.invoke('AgentSendMessage', { strMessageType: 'AgentLogOut', Message: this.Message }).then(() => {
        Vue.prototype.$connect.stop();
      });
    }
  },
  beforeRouteLeave: CustomerMcs.beforerouteleave,
};
</script>
